import React, { useContext, useState, useEffect } from "react";
import _ from "lodash";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import { Translate, Localize, getLocale, setLocale } from "react-i18nify";

import { useKioskHorizontalStyles } from "./../../../../kioskstyles";
import KioskStylesReact from "./../../../../KioskStylesReact";

import {
  Button,
  Grid,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  TextField,
  Typography,
  OutlinedInput,
  ButtonGroup
} from "@mui/material";
import CheckBoxOutlinedIcon from "@mui/icons-material/CheckBoxOutlined";
import ArrowDropDownCircleIcon from "@mui/icons-material/ArrowDropDownCircle";
import SentimentSatisfiedAltIcon from "@mui/icons-material/SentimentSatisfiedAlt";

import CircleButton from "./../../Components/Buttons/CircleButton";
import Logo from "./../../Components/Logo";
import KioskStepper from "./../../Components/Stepper/KioskStepper";
import KioskDetail from "./../../Components/Shared/KioskDetail";
import IdleTimerDisplay from "./../../Components/Shared/IdleTimerDisplay";
import SubtitleWrapper from "./../../Components/Shared/PanelElements/SubtitleWrapper";
import FlexLeftPanel from "./../../Components/Shared/PanelElements/FlexLeftPanel";
import FlexRightPanel from "./../../Components/Shared/PanelElements/FlexRightPanel";

import { StepIcon } from "./StepIcon";

import formatFirstNameLastInitial from "./../../HelperFunctions/formatFirstNameLastInitial";

import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

import { useTheme } from "@mui/material/styles";

import { Dlog } from "./../../../../utils/Dlog";

import HttpContext from "../../../../contexts/HTTP/HttpContext";
import KioskContext from "../../../../contexts/Kiosk/KioskContext";
import SocketIOContext from "../../../../contexts/Kiosk/SocketProvider/SocketIOContext";

import { useNavigate } from "react-router-dom";

import { IdleTimerContext, IdleTimerProvider } from "react-idle-timer";

import { WORKFLOW_MODES } from "../../../../constants";

import PrinterConnectionModal from "./../Shared/PrinterConnectionModal";

import "./../../../../font.css";

let env = require("./../../../../env");

export default function HorizontalLayout({
  authenticate,
  getKioskConfiguration
}) {
  const theme = useTheme();
  const { post } = useContext(HttpContext);

  const [loading, setLoading] = useState(false);

  const { getKioskTheme } = useContext(SocketIOContext);

  const {
    customerFirstName,
    customerLastName,
    customerID,
    charityName,
    charityID,
    setCustomerNameAndID,
    numBags,
    setNumBags,
    numLabels,
    setLabels,
    setAll,
    customerReset
  } = useContext(KioskContext);

  const navigate = useNavigate();

  const onIdle = async () => {
    if (env.IDLETIMER) {
      const kiosktheme = getKioskTheme();
      if (kiosktheme.bilingual) {
        setLocale("fr");
      }

      navigate("/language");
    }
  };

  const next = () => {
    Dlog("next called");
    customerReset();

    if (kiosktheme.bilingual) {
      setLocale("fr");
    }

    navigate("/language");
  };

  const kioskstyles = useKioskHorizontalStyles();

  const isNotMobile = useMediaQuery("(min-width:600px)");
  const isLandscape = useMediaQuery("(orientation:landscape)");

  const kiosktheme = getKioskTheme();
  const kioskconfiguration = getKioskConfiguration();

  useEffect(() => {
    if (kioskconfiguration == undefined || kioskconfiguration == null) {
      return navigate("/errorscreen");
    }
  }, []);

  //console.log("[DEBUG] KioskContext customerFirstName", customerFirstName);
  //console.log("[DEBUG] KioskContext customerLastName", customerLastName);
  //console.log("[DEBUG] KioskContext customerID", customerID);
  //console.log("[DEBUG] KioskContext charityName", charityName);
  //console.log("[DEBUG] KioskContext charityID", charityID);
  //console.log("[DEBUG] KioskContext numBags", numBags);
  //console.log("[DEBUG] KioskContext numLabels", numLabels);

  return (
    <IdleTimerProvider timeout={30000} onIdle={onIdle}>
      <Grid
        container
        rowSpacing={1}
        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        style={kioskstyles.GridFullHeightFix}
      >
        <FlexLeftPanel isNotMobile={isNotMobile}>
          <div style={kioskstyles.flexLeftPanelContents}>
            <div style={kioskstyles.flexParentPanel}>
              <div style={kioskstyles.flexPanelLayoutB_TopContainer}>
                <Logo />
              </div>
              <div style={kioskstyles.flexPanelLayoutB_MidContainer}>
                <div style={kioskstyles.kioskDetails}>
                  <div
                    class="fontSecondaryText"
                    style={kioskstyles.whiteSubtitleText}
                  >
                    <Translate
                      value="application.theme.wizardThanksText"
                      name={formatFirstNameLastInitial(
                        customerFirstName,
                        customerLastName
                      )}
                    />
                  </div>
                  <br />
                  <KioskDetail getKioskConfiguration={getKioskConfiguration} />
                  <br />
                  <div
                    class="fontSecondaryText"
                    style={{
                      ...kioskstyles.whiteBodyText,
                      ...kioskstyles.kioskDetailsSpaceBetween
                    }}
                  >
                    {/* <Translate
                      value="application.kioskdetail.returningnumbags"
                      count={numBags}
                    /> */}
                    <Translate value="application.theme.wizardReturningText" />{" "}
                    <b>
                      <Translate
                        value="application.theme.wizardBagsText"
                        count={numBags}
                      />
                    </b>
                  </div>

                  {kioskconfiguration?.workflowMode ==
                    WORKFLOW_MODES.BAGS_AND_LABELS && (
                    <>
                      <br />
                      <div
                        class="fontSecondaryText"
                        style={{
                          ...kioskstyles.whiteBodyText,
                          ...kioskstyles.kioskDetailsSpaceBetween
                        }}
                      >
                        <Translate value="application.theme.wizardPrintingText" />{" "}
                        <b>
                          <Translate
                            value="application.theme.wizardLabelsText"
                            count={numLabels}
                          />
                        </b>
                      </div>
                    </>
                  )}
                </div>
              </div>
              <div
                style={{
                  ...kioskstyles.flexPanelLayoutB_BotContainer,
                  alignItems: "start"
                }}
              >
                {" "}
                <Button
                  variant="contained"
                  disabled={loading}
                  onClick={next}
                  style={{
                    ...kioskstyles.textButtons,
                    borderRadius: "1.1vh",
                    marginBottom: "0px"
                  }}
                >
                  <span class="fontSecondaryText">
                    <Translate value="application.theme.thankyouFinishButtonText" />
                  </span>
                </Button>
              </div>
            </div>
          </div>
        </FlexLeftPanel>
        <FlexRightPanel isNotMobile={isNotMobile}>
          <div
            style={{
              ...kioskstyles.flexRightPanelContents,
              display: "flex",
              flexDirection: "column",
              height: "100%"
            }}
          >
            <div
              style={{
                ...kioskstyles.flexParentPanel,
                fontSize: "clamp(4.5px, 3.2vh, 28px)"
              }}
            >
              <div style={kioskstyles.flexPanelLayoutB_TopContainer}>
                <SubtitleWrapper isNotMobile={isNotMobile}>
                  <Translate value="application.theme.thankyouThankYouText" />
                </SubtitleWrapper>
              </div>
              <br />
              <div>
                <center>
                  {/* <CheckBoxOutlinedIcon
                    style={{ fontSize: "clamp(30px, 8vh, 120px)" }}
                    // style={{ fontSize: "clamp(30px, 5.5vw, 120px)" }}
                  /> */}
                  <StepIcon
                    DefaultIcon={"CheckBoxOutlined"}
                    cssSizeString="clamp(30px, 8vh, 120px)"
                    iconName={kiosktheme.thankyouStep1Icon}
                  />
                </center>
              </div>
              <span
                class="fontNormal"
                style={{
                  ...kioskstyles.blackBodyText
                }}
              >
                <b>
                  <Translate value="application.theme.thankyouStep1Header" />
                </b>{" "}
                <span style={kioskstyles.HelperTextColor}>
                  <Translate value="application.theme.thankyouStep1Body" />
                </span>
              </span>
              <br />
              <br />
              <div>
                <center>
                  {/* <ArrowDropDownCircleIcon
                    style={{ fontSize: "clamp(30px, 8vh, 120px)" }}
                  /> */}

                  <StepIcon
                    DefaultIcon={"ArrowDropDownCircle"}
                    cssSizeString="clamp(30px, 8vh, 120px)"
                    iconName={kiosktheme.thankyouStep2Icon}
                  />
                </center>
              </div>

              <span
                class="fontNormal"
                style={{
                  ...kioskstyles.blackBodyText
                }}
              >
                <b>
                  <Translate value="application.theme.thankyouStep2Header" />
                </b>{" "}
                <span style={kioskstyles.HelperTextColor}>
                  <Translate value="application.theme.thankyouStep2Body" />
                </span>
              </span>
              <br />
              <br />
              <div>
                <center>
                  {/* <SentimentSatisfiedAltIcon
                    style={{ fontSize: "clamp(30px, 8vh, 120px)" }}
                  /> */}
                  <StepIcon
                    DefaultIcon={"SentimentSatisfiedAlt"}
                    cssSizeString="clamp(30px, 8vh, 120px)"
                    iconName={kiosktheme.thankyouStep3Icon}
                  />
                </center>
              </div>

              <span
                class="fontNormal"
                style={{
                  ...kioskstyles.blackBodyText
                }}
              >
                <b>
                  <Translate value="application.theme.thankyouStep3Header" />
                </b>{" "}
                <span style={kioskstyles.HelperTextColor}>
                  <Translate
                    value="application.theme.thankyouStep3Body"
                    count={kiosktheme.daysToCount}
                  />
                </span>
              </span>
            </div>
          </div>
        </FlexRightPanel>
      </Grid>
      <IdleTimerDisplay />
      <PrinterConnectionModal />
    </IdleTimerProvider>
  );
}
